export default function generator(_ref) {
  var borders = _ref.borders,
    typography = _ref.typography,
    colors = _ref.colors,
    spacing = _ref.spacing;
  return {
    labelPadding: spacing.small,
    labelLeftPadding: spacing.large,
    labelBottomPadding: spacing.xxSmall,
    labelFontSize: typography.fontSizeSmall,
    labelColor: colors.slate,
    editButtonWrapperRightMargin: spacing.large,
    titleShowWrapperBottomBorder: "".concat(borders.widthMedium, " ").concat(borders.style, " ").concat(colors.porcelain),
    titleEditWrapperBorderWidth: borders.widthSmall,
    titleEditWrapperBorderColor: colors.ash
  };
}